export default "__VITE_ASSET__f2292431__"